import { IonPage, IonContent, IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonButton } from '@ionic/react';
import { useIsMobile } from '../hooks/useMediaQuery';
import { useUser } from '@clerk/clerk-react';

export function BillingPage() {
  const { user } = useUser();
  const isMobile = useIsMobile();

  return (
    <IonPage>
      <IonContent className="page-content bg-gray-50">
        <div className={`page-header ${isMobile ? 'page-header-mobile' : 'page-header-desktop'}`}>
          <div className="title">Billing</div>
        </div>
      </IonContent>
    </IonPage>
  );
}

